import { render, staticRenderFns } from "./Footerbar.vue?vue&type=template&id=1d619560&scoped=true"
import script from "./Footerbar.vue?vue&type=script&lang=js"
export * from "./Footerbar.vue?vue&type=script&lang=js"
import style0 from "./Footerbar.vue?vue&type=style&index=0&id=1d619560&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d619560",
  null
  
)

export default component.exports